import { frontendURL } from '../../../../helper/URLHelper';

const SettingsWrapper = () => import('../SettingsWrapper.vue');
const CreditUsageSettings = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/credit-usage'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'credit_usage_settings',
          component: CreditUsageSettings,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
